import { render, staticRenderFns } from "./StudipProgressIndicator.vue?vue&type=template&id=f74f6b64&"
import script from "./StudipProgressIndicator.vue?vue&type=script&lang=js&"
export * from "./StudipProgressIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports